import React, { useEffect } from 'react';
import { Card, Layout } from 'antd';
import { Outlet } from 'react-router-dom';
import MainMenu from '../menu/MainMenu';
import AppFooter from './AppFooter';
import AppHeader from './AppHeader';
import '../../styles/styles.less';
import { commonApiSlice } from '../../app/api/commonApiSlice';
import { useAppDispatch } from '../../app/hooks';

const AppLayout: React.FC = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    void dispatch(commonApiSlice.endpoints.getVehicleMakes.initiate());
    void dispatch(commonApiSlice.endpoints.getVehicleModels.initiate());
    void dispatch(commonApiSlice.endpoints.getVehicleGrades.initiate());
    void dispatch(commonApiSlice.endpoints.getVehicleColors.initiate());
    void dispatch(commonApiSlice.endpoints.getVehicleCylinders.initiate());
    void dispatch(commonApiSlice.endpoints.getVehicleConditions.initiate());
    void dispatch(commonApiSlice.endpoints.getVehicleTypes.initiate());
    void dispatch(commonApiSlice.endpoints.getVehicleLocation.initiate());
    void dispatch(commonApiSlice.endpoints.getVehicleCategories.initiate());
    void dispatch(commonApiSlice.endpoints.getFuelTypes.initiate());
    void dispatch(commonApiSlice.endpoints.getTransmissions.initiate());
    void dispatch(commonApiSlice.endpoints.getSellerCategories.initiate());
    void dispatch(commonApiSlice.endpoints.getYardTypes.initiate());
    void dispatch(commonApiSlice.endpoints.getVolumeOfPotential.initiate());
  }, []);

  return (
    <Layout
      style={{
        minHeight: '100vh',
      }}
    >
      <AppHeader />
      <Layout>
        <Layout.Sider
          breakpoint='lg'
          collapsedWidth='0'
          style={{
            borderRight: '1px solid #e1e1e1',
          }}
        >
          <MainMenu />
        </Layout.Sider>
        <Layout.Content style={{ margin: 16 }}>
          <Card>
            <Outlet />
          </Card>
          <AppFooter />
        </Layout.Content>
      </Layout>
    </Layout>
  );
};

export default AppLayout;
